import { Component, Inject, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICliente, IFacturacionCliente } from 'modelos/src';
import { FacturacionClientesService } from '../../../../auxiliares/servicios/http/facturacion-clientes.service';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';

export interface IDataDialogFacturacion {
  /** Cliente fijo (editar/crear para un cliente puntual). Si falta, se
   *  habilita el selector para elegir cualquier cliente (excepción). */
  cliente?: ICliente;
  facturacion?: IFacturacionCliente;
}

@Component({
  selector: 'app-crear-editar-facturacion',
  templateUrl: './crear-editar-facturacion.component.html',
  styleUrl: './crear-editar-facturacion.component.scss',
  standalone: false,
})
export class CrearEditarFacturacionComponent implements OnInit {
  public dialogRef =
    inject<MatDialogRef<CrearEditarFacturacionComponent>>(MatDialogRef);
  private service = inject(FacturacionClientesService);
  private helper = inject(HelperService);

  public form?: FormGroup;
  public loading = false;
  public title = '';
  /** Modo excepción: sin cliente fijo, se elige con el selector. */
  public seleccionable = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IDataDialogFacturacion,
  ) {}

  ngOnInit(): void {
    const f = this.data?.facturacion;
    this.seleccionable = !this.data?.cliente;
    this.title = this.seleccionable
      ? 'Nueva excepción de facturación'
      : `Facturación — ${this.data?.cliente?.nombre ?? ''}`;
    this.form = new FormGroup({
      idClienteSeleccionado: new FormControl(
        this.data?.cliente?._id ?? null,
        this.seleccionable ? Validators.required : [],
      ),
      activa: new FormControl(f?.activa ?? true),
      bonificado: new FormControl(f?.bonificado ?? false),
    });
  }

  public async onSubmit(): Promise<void> {
    if (!this.form?.valid) {
      this.form?.markAllAsTouched();
      return;
    }
    this.loading = true;
    try {
      const v = this.form.value;
      const payload = {
        activa: v.activa,
        bonificado: v.bonificado,
      };
      const id = this.data?.facturacion?._id;
      if (id) {
        await this.service.update(id, payload);
        this.helper.notifSuccess('Facturación actualizada');
      } else {
        const idCliente = this.data?.cliente?._id ?? v.idClienteSeleccionado;
        await this.service.create({ ...payload, idCliente });
        this.helper.notifSuccess('Facturación creada');
      }
      this.dialogRef.close(true);
    } catch (error) {
      console.error('Error guardando facturación', error);
      this.helper.notifError('No se pudo guardar la facturación');
    } finally {
      this.loading = false;
    }
  }
}
